import {FormattedMessage, IntlShape} from 'react-intl';
import {OfferType} from '.cache/__types__';
import {LocaleType, LocaleEnum} from 'src/types/general';

export const translations = {
    [OfferType.Undefined]: <FormattedMessage defaultMessage="Nevyplněno" />,
    [OfferType.Prodej]: <FormattedMessage defaultMessage="Prodej" />,
    [OfferType.Pronajem]: <FormattedMessage defaultMessage="Pronájem" />,
    [OfferType.Spolubydleni]: <FormattedMessage defaultMessage="Spolubydlení" />,
};

export const imperativeTranslations = {
    [OfferType.Undefined]: (intl: IntlShape) => intl.formatMessage({defaultMessage: 'Nevyplněno'}),
    [OfferType.Prodej]: (intl: IntlShape) => intl.formatMessage({defaultMessage: 'Prodej'}),
    [OfferType.Pronajem]: (intl: IntlShape) => intl.formatMessage({defaultMessage: 'Pronájem'}),
    [OfferType.Spolubydleni]: (intl: IntlShape) => intl.formatMessage({defaultMessage: 'Spolubydlení'}),
};

export const getImperativeTranslation = (intl: IntlShape, key: OfferType) => imperativeTranslations[key](intl);

export const localizedListSlugs: Record<LocaleType, Record<Exclude<OfferType, OfferType.Undefined>, string>> = {
    [LocaleEnum.cs]: {
        [OfferType.Prodej]: 'nabidka-prodej',
        [OfferType.Pronajem]: 'nabidka-pronajem',
        [OfferType.Spolubydleni]: 'nabidka-spolubydleni',
    },
    [LocaleEnum.sk]: {
        [OfferType.Prodej]: 'ponuka-predaj',
        [OfferType.Pronajem]: 'ponuka-prenajom',
        [OfferType.Spolubydleni]: 'ponuka-spolubyvanie',
    },
    [LocaleEnum.en]: {
        [OfferType.Prodej]: 'offer-sale',
        [OfferType.Pronajem]: 'offer-rent',
        [OfferType.Spolubydleni]: 'offer-share',
    },
};

export const label = <FormattedMessage defaultMessage="Typ nabídky" />

export const listDefaultType = OfferType.Prodej;
